import React from 'react'

import { Dropdown, Menu } from 'antd'
import { Formik, FormikProps } from 'formik'

import { EmployeeReimbursementsDue } from 'core/application/adminDashboard/reimbursements/reimbursementsDue/getReimbursementsDue'

import InputNumber from 'common/components/dataEntry/formik/FormikDefaultInputNumberField'
import Icon from 'common/components/general/Icon'

import { formatMoney } from 'common/moneyFormatter'

import { DropdownVisible, ReimbursementsDueToSubmit } from '../index'

import './SelectReimbursementDueAmount.less'

interface SelectReimbursementDueAmountProps {
  item: number
  record: EmployeeReimbursementsDue
  formik: FormikProps<any>
  translate: (key: string) => string
  reimbursementsDueToSubmit: ReimbursementsDueToSubmit[]
  dropdownVisible: DropdownVisible[]
  setDropdownVisibility: (key: string, visible: boolean) => void
  setReimbursementsDue: (key: string, amount: number) => void
}

const reimbursementDueMenu = (
  fullReimbursementDue: number,
  record: EmployeeReimbursementsDue,
  formik: FormikProps<any>,
  translate: (key: string) => string,
  setDropdownVisibility: (key: string, visible: boolean) => void,
  setReimbursementsDue: (key: string, amount: number) => void,
) => {
  const getReimbursementDueAmount = (targetValue: number): number => {
    if (targetValue > 0 && targetValue <= fullReimbursementDue) {
      return targetValue
    } else {
      return fullReimbursementDue
    }
  }

  return (
    <Menu>
      <Menu.Item
        key="0"
        onClick={() => {
          formik.setFieldValue(record.companyUserId, '')
          setReimbursementsDue(record.companyUserId, fullReimbursementDue)
          setDropdownVisibility(record.companyUserId, false)
        }}
      >
        {translate('admin-dashboard.reimbursements.reimbursements-due.full-amount-label')}:{' '}
        {formatMoney(fullReimbursementDue)}
      </Menu.Item>
      <Menu.Item key="1">
        {translate('admin-dashboard.reimbursements.reimbursements-due.other-amount-label')} <br />
        <InputNumber
          name={record.companyUserId}
          onPressEnter={(e: any) => {
            const targetValue = +e.target.value
            setReimbursementsDue(record.companyUserId, getReimbursementDueAmount(targetValue))
            setDropdownVisibility(record.companyUserId, false)
          }}
          min={1}
          className="other_amount_input_number"
          placeholder="$"
        />
      </Menu.Item>
    </Menu>
  )
}

const SelectReimbursementDueAmount: React.FC<SelectReimbursementDueAmountProps> = (props) => {
  const visible = props.dropdownVisible.find((item) => item.key === props.record.companyUserId)?.visible
  const selectedAmount = props.reimbursementsDueToSubmit.find(
    (item) => item.companyUserId === props.record.companyUserId,
  )

  let selectedAmountValue = 0
  if (selectedAmount !== undefined) {
    if (selectedAmount.overrideReimbursementDue) {
      selectedAmountValue = selectedAmount.overrideReimbursementDue
    } else {
      selectedAmountValue = selectedAmount.originalReimbursementDue
    }
  }

  return (
    <Dropdown
      overlay={reimbursementDueMenu(
        props.item,
        props.record,
        props.formik,
        props.translate,
        props.setDropdownVisibility,
        props.setReimbursementsDue,
      )}
      trigger={['click']}
      placement="bottomLeft"
      open={visible}
      onVisibleChange={(flag) => {
        if (!flag) {
          const otherAmountValue: number = props.formik.getFieldMeta<number>(props.record.companyUserId).value
          if (
            selectedAmount !== undefined &&
            otherAmountValue !== undefined &&
            otherAmountValue > 0 &&
            otherAmountValue <= selectedAmount.originalReimbursementDue
          ) {
            props.setReimbursementsDue(props.record.companyUserId, otherAmountValue)
          }
        }
        props.setDropdownVisibility(props.record.companyUserId, flag)
      }}
    >
      <h6 className="reimbursement_due_selected_amount">
        {formatMoney(selectedAmountValue)} <Icon type="far fa-angle-down" fontAwesome />
      </h6>
    </Dropdown>
  )
}

export default SelectReimbursementDueAmount
